import {axiosInstance} from './axios';

export async function getTravelsApi(query='') {
  try {
    return await axiosInstance.get(`/api/v1/travels?${query}`)
  }catch (e) {
    return null;
  }
}

export async function assignToBusApi(id,data) {
  try {
    return await axiosInstance.post(`/api/v1/travels/${id}/assign`,data)
  }catch (e) {
    return null;
  }
}

export async function addTravelApi(data) {
  try {
    return await axiosInstance.post("/api/v1/travels",data)
  }catch (e) {
    return null;
  }
}

export async function getTravelApi(id) {
  try {
    return await axiosInstance.get(`/api/v1/travels/${id}`)
  }catch (e) {
    return null;
  }
}

export async function removeTravelApi(id) {
  try {
    return await axiosInstance.delete(`/api/v1/travels/${id}`)
  }catch (e) {
    return null;
  }
}
export async function editTravelApi(data,id) {
  try {
    return await axiosInstance.put(`/api/v1/travels/${id}`,data)
  }catch (e) {
    return null;
  }
}
export async function assignTirpToBus(id,data) {
  try {
    return await axiosInstance.put(`/api/v1//travels-details/${id}`,data)
  }catch (e) {
    return null;
  }
}
export async function getAssignTirpToBus(id) {
  try {
    return await axiosInstance.get(`/api/v1/travels-details/${id}`)
  }catch (e) {
    return null;
  }
}

export async function createTirpDetails(data) {
  try {
    return await axiosInstance.post(`/api/v1/travels-details`,data)
  }catch (e) {
    return null;
  }
}

export async function getReportDetails() {
  try {
    return await axiosInstance.get(`/api/v1/travel-details/report`)
  }catch (e) {
    return null;
  }
}
